import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { Dialog } from "component/shared/dialog";
import { Agent } from "model/agent";
import { styles } from "../style";
import * as env from "shared/env";

interface Props extends WithStyles<typeof styles> {
	agent: Agent;
	deleteAgentDialogIsOpen: boolean;
	hideDeleteAgentDialog: Function;
	deleteAgent: Function;
}

const component = (props: Props) => {
	const {
		agent,
		classes = {},
		deleteAgent,
		deleteAgentDialogIsOpen,
		hideDeleteAgentDialog,
	} = props;

	return (
		<Dialog
			open={deleteAgentDialogIsOpen}
			onClose={() => hideDeleteAgentDialog()}
		>
			<Mui.DialogTitle>Delete Agent</Mui.DialogTitle>
			<Mui.DialogContent className={classes.dialogContent}>
				<Mui.DialogContentText>
					{`Are you sure you want to delete ${agent.firstName} ${agent.lastName}?`}
				</Mui.DialogContentText>
			</Mui.DialogContent>
			<Mui.DialogActions className={classes.dialogActions}>
				<Mui.Button onClick={() => hideDeleteAgentDialog()} variant="outlined" color={"primary"}>
					No
				</Mui.Button>
				<Mui.Button
					onClick={() => deleteAgent()}
					variant="contained"
					color={"primary"}
				>
					Yes
				</Mui.Button>
			</Mui.DialogActions>
		</Dialog>
	);
};

export const DeleteAgentDialog = withStyles(component, styles);
